import React, { PureComponent } from 'react';
import CompletedRenewalsReportsPage from '../../../presenters/reports/ReportsPortalPage/CompletedRenewalsReportsPage';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';

class ReportsPortal extends PureComponent {
  render() {
    return (
      <div>
        <CompletedRenewalsReportsPage />
      </div>
    );
  }
}

export default withRouter(injectIntl(ReportsPortal));
